module.exports = __webpack_public_path__ + "img/icon-shoucangfill.099b32c7.svg";